// The trial banner (DESIGN §2.3): "Trying: <summary> · Keep · Changes ·
// Cancel" under the top row while this device runs a trial, collapsible to
// a chip. `banner` is lib/launch.js trialBanner(); buttons come from the
// server's actions and the ready gate only.
import { Button, NoticeCard, Spinner } from '../../ui/components.jsx';
import { Glyph } from '../../ui/glyphs.jsx';
import { actionLabel } from '../../lib/cards.js';

export function TrialBanner({ banner, standalone, busy, error, onAction, onCollapse, onOpenCoding, onRetryWrite, onDismissWrite }) {
  const working = banner.tone === 'working';
  const lead = banner.state === 'trying' ? 'Trying: ' : `${banner.title} · `;
  return (
    <div class={`mt-trial mt-tone-${banner.tone}${standalone ? ' mt-standalone' : ''}`} role="region" aria-label="The change you’re trying">
      <div class="mt-trial-head">
        {working && <Spinner />}
        <p class="mt-trial-text"><b>{lead}</b>{banner.text}</p>
        <button type="button" class="mt-icon-btn" aria-label="Hide these choices" aria-expanded="true" onClick={onCollapse}>
          <Glyph name="expand" class="mt-rot180" />
        </button>
      </div>
      {(banner.buttons.length > 0 || banner.coding) && (
        <div class="mt-trial-actions">
          {banner.buttons.map((a) => (
            <Button kind={a === 'keep' ? 'filled' : 'text'} disabled={busy} onClick={() => onAction(a)}>
              {a === 'revise' ? 'Change something' : actionLabel(a)}
            </Button>
          ))}
          {banner.coding && <Button kind="filled" onClick={onOpenCoding}>Open Coding</Button>}
        </div>
      )}
      {banner.hint && <p class="mt-trial-hint">{banner.hint}</p>}
      {error && (
        <div class="mt-trial-error">
          <NoticeCard tone="problem" title="A change is waiting to send" body={error.message} role="alert"
            actions={[{ label: 'Try again', onClick: onRetryWrite, disabled: busy }, { label: 'Dismiss', onClick: onDismissWrite, disabled: busy }]} />
        </div>
      )}
    </div>
  );
}

/** The collapsed banner: a small chip at the top edge. */
export function TrialChip({ banner, top, onExpand }) {
  return (
    <button type="button" class="mt-trial-chip" style={`top:${top}`} aria-expanded="false"
      aria-label={`${banner.state === 'trying' ? 'Trying a change' : banner.title}. Show the choices`} onClick={onExpand}>
      <span class="mt-dot" aria-hidden="true" />
      {banner.state === 'trying' ? 'Trying' : banner.title}
      <Glyph name="expand" />
    </button>
  );
}
